import { render, staticRenderFns } from "./gongxian.vue?vue&type=template&id=0366ae7c&scoped=true"
import script from "./gongxian.vue?vue&type=script&lang=js"
export * from "./gongxian.vue?vue&type=script&lang=js"
import style0 from "./gongxian.vue?vue&type=style&index=0&id=0366ae7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0366ae7c",
  null
  
)

export default component.exports